enum measurementsOldNames {
  blood_pressure = "Blood Pressure",
  ecg = "ECG",
  glucose = "Glucose",
  scale = "Scale",
  temperature = "Temperature",
}
export default measurementsOldNames;
